import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UtilsService } from 'src/app/shared/services/utils.service';

import { L10nTranslationService } from '@snack-dev/angular-l10n';

@Component({
  selector: 'hs-translations-updater',
  templateUrl: './translations-updater.component.html',
  styleUrls: ['./translations-updater.component.scss']
})
export class TranslationsUpdaterComponent implements OnInit {

  pulling = true;
  error = false;
  spinnerName = 'translation-updater';
  title: string;

  constructor(
    public bsModal: BsModalRef,
    private translation: L10nTranslationService,
    private utilsService: UtilsService,
  ) { }

  ngOnInit(): void {
    this.utilsService.pullTranslations().subscribe((_) => {
      this.invalidateCaches();
      // Add some fixed time so the POST requests to invalidate caches will be executed
      setTimeout(() => {
        this.pulling = false;
        this.error = false;
      }, 2000);
    }, (error) => {
      this.pulling = false;
      this.error = true;
    });
  }

  /**
   * The only workaround we have right now to invalidate the cache of certain files
   * is to make a POST request to the file from a form inside an iframe.
   * This creates an iframe and form for each file, makes the POST request and
   * removed the iframe from the page.
   *
   * This is used only internally (for admins) so it shouldn't be an issue.
   * If that were ever to change, this needs to be replaced or completely eliminated
   * as it's a terrible experience for the end-user.
   */
  invalidateCaches() {
    const langs = this.translation.getAvailableLanguages();
    for (const lang of langs) {
      const ifr = document.createElement('iframe');
      ifr.name = ifr.id = 'ifr_' + lang;
      document.body.appendChild(ifr);
      const form = document.createElement('form');
      form.method = 'POST';
      form.target = ifr.name;
      form.action = `/assets/i18n/${lang}.json`;
      document.body.appendChild(form);
      form.submit();
      setTimeout(() => {
        document.body.removeChild(ifr);
        document.body.removeChild(form);
      }, 3000);
    }
  }

  reloadPage() {
    location.reload();
  }

}
